// @ts-nocheck
/**
 * ドロップテーブル定義
 *
 * 構造:
 * - floors: フロア別ドロップ（大陸×深度）
 * - bosses: ボス別ドロップ
 * - chests: 宝箱ドロップ
 * - events: イベント報酬
 */

/**
 * フロア別ドロップテーブル
 * continents.js の定義に準拠
 */
export const FLOOR_DROP_TABLES = {
  // デフォルト
  default: {
    materials: [
      { item: '魔力の核', chance: 0.8, countRange: [1, 3] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '秘宝の欠片', weight: 1 },
    ],
  },

  // ========== 巨鳥の島アヴィクルス（炎・光）==========
  aviculus_depth_1: {
    materials: [
      { item: '炎の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '光の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
      { item: '竜鱗', chance: 0.15, countRange: [1, 2] },
      { item: '聖光の結晶', chance: 0.1, countRange: [1, 1] },
    ],
    rareChance: 0.08,
    rarePool: [
      { item: '天空の羽根', weight: 3 },
      { item: '竜王の逆鱗', weight: 2 },
      { item: '聖女の祈り', weight: 1 },
    ],
  },
  aviculus_depth_2: {
    materials: [
      { item: '炎の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '光の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '竜鱗', chance: 0.25, countRange: [1, 3] },
      { item: '聖光の結晶', chance: 0.2, countRange: [1, 2] },
      { item: '天空の羽根', chance: 0.1, countRange: [1, 1] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: '竜王の逆鱗', weight: 3 },
      { item: '不死鳥の炎羽', weight: 2 },
      { item: '聖女の祈り', weight: 1 },
    ],
  },
  aviculus_depth_3: {
    materials: [
      { item: '炎の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '光の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '竜鱗', chance: 0.4, countRange: [2, 4] },
      { item: '聖光の結晶', chance: 0.3, countRange: [1, 3] },
      { item: '天空の羽根', chance: 0.2, countRange: [1, 2] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '不死鳥の炎羽', weight: 2 },
      { item: '始祖竜の心臓', weight: 1 },
      { item: '聖女の祈り', weight: 1 },
    ],
  },

  // ========== 黒呪の大陸（闇・水）==========
  black_curse_depth_1: {
    materials: [
      { item: '闇の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '水の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
      { item: '呪縛の鎖', chance: 0.15, countRange: [1, 2] },
      { item: '潮流の結晶', chance: 0.1, countRange: [1, 1] },
    ],
    rareChance: 0.08,
    rarePool: [
      { item: '深淵の闘気', weight: 3 },
      { item: '海神の涙', weight: 2 },
      { item: '怨念の残滓', weight: 1 },
    ],
  },
  black_curse_depth_2: {
    materials: [
      { item: '闇の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '水の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '呪縛の鎖', chance: 0.25, countRange: [1, 3] },
      { item: '潮流の結晶', chance: 0.2, countRange: [1, 2] },
      { item: '魔力結晶', chance: 0.1, countRange: [1, 1] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: '深淵の闘気', weight: 2 },
      { item: '海神の涙', weight: 2 },
      { item: '珊瑚の心臓', weight: 1 },
    ],
  },
  black_curse_depth_3: {
    materials: [
      { item: '闇の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '水の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '呪縛の鎖', chance: 0.4, countRange: [2, 4] },
      { item: '潮流の結晶', chance: 0.3, countRange: [1, 3] },
      { item: '魔力結晶', chance: 0.2, countRange: [1, 2] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '深淵の闘気', weight: 2 },
      { item: '珊瑚の心臓', weight: 1 },
      { item: '怨念の残滓', weight: 1 },
    ],
  },

  // ========== 蒸気の境界（炎・水）==========
  steam_boundary_depth_1: {
    materials: [
      { item: '炎の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '水の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
      { item: '竜鱗', chance: 0.1, countRange: [1, 2] },
      { item: '潮流の結晶', chance: 0.1, countRange: [1, 1] },
    ],
    rareChance: 0.08,
    rarePool: [
      { item: '天空の羽根', weight: 2 },
      { item: '海神の涙', weight: 2 },
      { item: '溶岩核', weight: 1 },
    ],
  },
  steam_boundary_depth_2: {
    materials: [
      { item: '炎の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '水の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '竜鱗', chance: 0.2, countRange: [1, 3] },
      { item: '潮流の結晶', chance: 0.2, countRange: [1, 2] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: '竜王の逆鱗', weight: 2 },
      { item: '海神の涙', weight: 2 },
      { item: '溶岩核', weight: 1 },
    ],
  },
  steam_boundary_depth_3: {
    materials: [
      { item: '炎の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '水の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '竜鱗', chance: 0.35, countRange: [2, 4] },
      { item: '潮流の結晶', chance: 0.3, countRange: [1, 3] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '不死鳥の炎羽', weight: 2 },
      { item: '珊瑚の心臓', weight: 2 },
      { item: '炉心の結晶', weight: 1 },
    ],
  },

  // ========== 黄昏の境界（光・闇）==========
  twilight_realm_depth_1: {
    materials: [
      { item: '光の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '闇の結晶', chance: 0.5, countRange: [2, 4] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
    ],
    rareChance: 0.1,
    rarePool: [
      { item: '黄昏の欠片', weight: 3 },
      { item: '均衡の石', weight: 1 },
    ],
  },
  twilight_realm_depth_2: {
    materials: [
      { item: '光の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '闇の結晶', chance: 0.6, countRange: [4, 7] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '聖光の結晶', chance: 0.15, countRange: [1, 2] },
      { item: '呪縛の鎖', chance: 0.15, countRange: [1, 2] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: '黄昏の欠片', weight: 2 },
      { item: '聖女の祈り', weight: 1 },
      { item: '深淵の闘気', weight: 1 },
    ],
  },
  twilight_realm_depth_3: {
    materials: [
      { item: '光の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '闇の結晶', chance: 0.7, countRange: [6, 10] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '聖光の結晶', chance: 0.25, countRange: [1, 3] },
      { item: '呪縛の鎖', chance: 0.25, countRange: [1, 3] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '均衡の石', weight: 2 },
      { item: '聖女の祈り', weight: 1 },
      { item: '深淵の闘気', weight: 1 },
    ],
  },

  // ========== 時空の狭間（未来）==========
  time_rift_depth_1: {
    materials: [
      { item: '未来の結晶', chance: 0.7, countRange: [2, 5] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
      { item: '機械部品', chance: 0.2, countRange: [1, 2] },
    ],
    rareChance: 0.08,
    rarePool: [
      { item: '時空の砂', weight: 3 },
      { item: 'エネルギーコア', weight: 1 },
    ],
  },
  time_rift_depth_2: {
    materials: [
      { item: '未来の結晶', chance: 0.8, countRange: [4, 8] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '機械部品', chance: 0.35, countRange: [1, 3] },
      { item: '時空の砂', chance: 0.15, countRange: [1, 1] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: 'エネルギーコア', weight: 2 },
      { item: '次元の鍵', weight: 1 },
    ],
  },
  time_rift_depth_3: {
    materials: [
      { item: '未来の結晶', chance: 0.9, countRange: [6, 12] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '機械部品', chance: 0.5, countRange: [2, 4] },
      { item: '時空の砂', chance: 0.3, countRange: [1, 2] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '次元の鍵', weight: 2 },
      { item: 'エネルギーコア', weight: 1 },
    ],
  },

  // ========== 原始の深淵（原始）==========
  primal_depths_depth_1: {
    materials: [
      { item: '原始の結晶', chance: 0.7, countRange: [2, 5] },
      { item: '魔力の核', chance: 0.5, countRange: [1, 3] },
      { item: '獣の牙', chance: 0.25, countRange: [1, 2] },
    ],
    rareChance: 0.08,
    rarePool: [
      { item: '粘液核', weight: 3 },
      { item: '獣王の牙', weight: 1 },
    ],
  },
  primal_depths_depth_2: {
    materials: [
      { item: '原始の結晶', chance: 0.8, countRange: [4, 8] },
      { item: '魔力の核', chance: 0.6, countRange: [2, 4] },
      { item: '獣の牙', chance: 0.4, countRange: [1, 3] },
      { item: '粘液核', chance: 0.2, countRange: [1, 2] },
    ],
    rareChance: 0.12,
    rarePool: [
      { item: '獣王の牙', weight: 2 },
      { item: '世界樹の雫', weight: 1 },
    ],
  },
  primal_depths_depth_3: {
    materials: [
      { item: '原始の結晶', chance: 0.9, countRange: [6, 12] },
      { item: '魔力の核', chance: 0.7, countRange: [3, 6] },
      { item: '獣の牙', chance: 0.5, countRange: [2, 4] },
      { item: '粘液核', chance: 0.35, countRange: [1, 3] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '世界樹の雫', weight: 2 },
      { item: '獣王の牙', weight: 1 },
    ],
  },

  // ========== 未知の領域（なし）==========
  unknown_depth_1: {
    materials: [
      { item: '魔力の核', chance: 0.8, countRange: [2, 5] },
    ],
    rareChance: 0.06,
    rarePool: [
      { item: '秘宝の欠片', weight: 1 },
    ],
  },
  unknown_depth_2: {
    materials: [
      { item: '魔力の核', chance: 0.9, countRange: [4, 8] },
    ],
    rareChance: 0.10,
    rarePool: [
      { item: '秘宝の欠片', weight: 1 },
    ],
  },
  unknown_depth_3: {
    materials: [
      { item: '魔力の核', chance: 1.0, countRange: [6, 12] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '秘宝の欠片', weight: 1 },
    ],
  },
};

/**
 * ボス別ドロップテーブル（カードID固有）
 */
export const BOSS_DROP_TABLES = {
  default: {
    guaranteed: [
      { type: 'material', item: '魔力の核', count: 10 },
    ],
    rareDrops: [
      { type: 'material', item: '秘宝の欠片', chance: 0.3, count: 1 },
    ],
    firstClearBonus: [
      { type: 'material', item: '秘宝の欠片', count: 3 },
    ],
  },

  // ========== アクアレギナストーリー ボス ==========
  corrupted_sea_serpent: {
    guaranteed: [
      { type: 'material', item: '水の結晶', count: 30 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '海神の涙', chance: 0.5, count: 2 },
      { type: 'recipe', item: 'tidal_staff', chance: 0.1, count: 1 },
    ],
    firstClearBonus: [
      { type: 'material', item: '守護者の欠片', count: 1 },
    ],
  },

  coral_guardian: {
    guaranteed: [
      { type: 'material', item: '水の結晶', count: 50 },
      { type: 'material', item: '守護者の欠片', count: 2 },
    ],
    rareDrops: [
      { type: 'material', item: '珊瑚の心臓', chance: 0.3, count: 1 },
      { type: 'recipe', item: 'coral_ring', chance: 0.15, count: 1 },
    ],
    firstClearBonus: [
      { type: 'passive', item: 'coral_blessing', count: 1 },
    ],
  },

  tide_guardian: {
    guaranteed: [
      { type: 'material', item: '水の結晶', count: 60 },
      { type: 'material', item: '守護者の欠片', count: 3 },
      { type: 'material', item: '海神の涙', count: 5 },
    ],
    rareDrops: [
      { type: 'material', item: '海神の涙', chance: 0.4, count: 2 },
      { type: 'equipment', item: 'tide_ring', chance: 0.2, count: 1 },
    ],
    firstClearBonus: [
      { type: 'equipment', item: 'tide_ring', count: 1 },
    ],
  },

  abyss_king: {
    guaranteed: [
      { type: 'material', item: '闇の結晶', count: 100 },
      { type: 'material', item: '深淵の闘気', count: 10 },
    ],
    rareDrops: [
      { type: 'material', item: '深淵の闘気', chance: 0.2, count: 1 },
      { type: 'recipe', item: 'abyss_blade', chance: 0.05, count: 1 },
    ],
    firstClearBonus: [
      { type: 'equipment', item: 'abyss_crown', count: 1 },
    ],
  },

  primordial_abyss: {
    guaranteed: [
      { type: 'material', item: '闇の結晶', count: 200 },
      { type: 'material', item: '深淵の闘気', count: 30 },
      { type: 'material', item: '原初の結晶', count: 1 },
    ],
    rareDrops: [
      { type: 'material', item: 'GR素材', chance: 0.5, count: 3 },
      { type: 'recipe', item: 'aqua_regina_scepter', chance: 0.1, count: 1 },
    ],
    firstClearBonus: [
      { type: 'equipment', item: 'aqua_regina_crown', count: 1 },
      { type: 'title', item: 'sea_inheritor', count: 1 },
    ],
  },
};

/**
 * カテゴリ別ボスドロップテーブル
 * キー: カテゴリ名（【】含む）
 * 通常のカテゴリドロップより豪華
 */
export const CATEGORY_BOSS_DROP_TABLES = {
  '【ドラゴン】': {
    guaranteed: [
      { type: 'material', item: '炎の結晶', count: 50 },
      { type: 'material', item: '竜鱗', count: 10 },
    ],
    rareDrops: [
      { type: 'material', item: '竜王の逆鱗', chance: 0.4, count: 2 },
      { type: 'recipe', item: 'dragon_fang', chance: 0.1, count: 1 },
    ],
    firstClearBonus: [
      { type: 'material', item: '不死鳥の炎羽', count: 1 },
    ],
  },
  '【ワイバーン】': {
    guaranteed: [
      { type: 'material', item: '竜鱗', count: 8 },
      { type: 'material', item: '炎の結晶', count: 20 },
    ],
    rareDrops: [
      { type: 'material', item: '竜王の逆鱗', chance: 0.2, count: 1 },
    ],
  },
  '【フェニックス】': {
    guaranteed: [
      { type: 'material', item: '天空の羽根', count: 10 },
      { type: 'material', item: '炎の結晶', count: 30 },
    ],
    rareDrops: [
      { type: 'material', item: '不死鳥の炎羽', chance: 0.3, count: 1 },
    ],
  },
  '【海竜】': {
    guaranteed: [
      { type: 'material', item: '水の結晶', count: 50 },
      { type: 'material', item: '海神の涙', count: 8 },
    ],
    rareDrops: [
      { type: 'material', item: '海神の涙', chance: 0.3, count: 1 },
    ],
  },
  '【クラーケン】': {
    guaranteed: [
      { type: 'material', item: '海神の涙', count: 8 },
      { type: 'material', item: '水の結晶', count: 40 },
    ],
    rareDrops: [
      { type: 'material', item: '海神の涙', chance: 0.25, count: 1 },
    ],
  },
  '【マーメイド】': {
    guaranteed: [
      { type: 'material', item: '潮流の結晶', count: 8 },
      { type: 'material', item: '海神の涙', count: 5 },
    ],
    rareDrops: [
      { type: 'material', item: '珊瑚の心臓', chance: 0.2, count: 1 },
    ],
  },
  '【天使】': {
    guaranteed: [
      { type: 'material', item: '光の結晶', count: 50 },
      { type: 'material', item: '聖女の祈り', count: 5 },
    ],
    rareDrops: [
      { type: 'material', item: '秘宝の欠片', chance: 0.25, count: 1 },
    ],
  },
  '【聖獣】': {
    guaranteed: [
      { type: 'material', item: '聖光の結晶', count: 10 },
      { type: 'material', item: '聖光の結晶', count: 8 },
    ],
    rareDrops: [
      { type: 'material', item: '聖女の祈り', chance: 0.2, count: 1 },
    ],
  },
  '【デーモン】': {
    guaranteed: [
      { type: 'material', item: '闇の結晶', count: 50 },
      { type: 'material', item: '深淵の闘気', count: 5 },
    ],
    rareDrops: [
      { type: 'material', item: '怨念の残滓', chance: 0.3, count: 2 },
    ],
  },
  '【魔女】': {
    guaranteed: [
      { type: 'material', item: '魔力結晶', count: 10 },
      { type: 'material', item: '呪縛の鎖', count: 8 },
    ],
    rareDrops: [
      { type: 'material', item: '深淵の闘気', chance: 0.2, count: 1 },
    ],
  },
  '【ゴースト】': {
    guaranteed: [
      { type: 'material', item: '怨念の残滓', count: 10 },
      { type: 'material', item: '闇の結晶', count: 30 },
    ],
    rareDrops: [
      { type: 'material', item: '深淵の闘気', chance: 0.2, count: 1 },
    ],
  },
  '【粘液獣】': {
    guaranteed: [
      { type: 'material', item: '粘液核', count: 15 },
      { type: 'material', item: '原始の結晶', count: 20 },
    ],
    rareDrops: [
      { type: 'material', item: '世界樹の雫', chance: 0.2, count: 1 },
    ],
  },
  '【ビースト】': {
    guaranteed: [
      { type: 'material', item: '獣の牙', count: 10 },
      { type: 'material', item: '原始の結晶', count: 25 },
    ],
    rareDrops: [
      { type: 'material', item: '獣王の牙', chance: 0.2, count: 1 },
    ],
  },
  '【ゴーレム】': {
    guaranteed: [
      { type: 'material', item: '魔力のコア', count: 8 },
      { type: 'material', item: '原始の結晶', count: 30 },
    ],
    rareDrops: [
      { type: 'material', item: '古代のコア', chance: 0.15, count: 1 },
    ],
  },
  '【マシン】': {
    guaranteed: [
      { type: 'material', item: '機械部品', count: 15 },
      { type: 'material', item: 'エネルギーコア', count: 3 },
    ],
    rareDrops: [
      { type: 'material', item: '次元の鍵', chance: 0.2, count: 1 },
    ],
  },
  '【トラベラー】': {
    guaranteed: [
      { type: 'material', item: '時空の砂', count: 10 },
      { type: 'material', item: '未来の結晶', count: 40 },
    ],
    rareDrops: [
      { type: 'material', item: '次元の鍵', chance: 0.25, count: 1 },
    ],
  },
};

/**
 * 属性別ボスドロップテーブル
 * カテゴリテーブルもない場合のフォールバック
 */
export const ATTRIBUTE_BOSS_DROP_TABLES = {
  '炎': {
    guaranteed: [
      { type: 'material', item: '炎の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: 'フェニックスの羽根', chance: 0.2, count: 1 },
    ],
  },
  '水': {
    guaranteed: [
      { type: 'material', item: '水の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '深海の真珠', chance: 0.2, count: 1 },
    ],
  },
  '光': {
    guaranteed: [
      { type: 'material', item: '光の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '聖なる光', chance: 0.2, count: 1 },
    ],
  },
  '闇': {
    guaranteed: [
      { type: 'material', item: '闇の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '呪いの残滓', chance: 0.2, count: 1 },
    ],
  },
  '原始': {
    guaranteed: [
      { type: 'material', item: '原始の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '太古の化石', chance: 0.2, count: 1 },
    ],
  },
  '未来': {
    guaranteed: [
      { type: 'material', item: '未来の結晶', count: 40 },
      { type: 'material', item: '魔力の核', count: 15 },
    ],
    rareDrops: [
      { type: 'material', item: '時空の欠片', chance: 0.2, count: 1 },
    ],
  },
  'なし': {
    guaranteed: [
      { type: 'material', item: '魔力の核', count: 25 },
    ],
    rareDrops: [
      { type: 'material', item: '秘宝の欠片', chance: 0.25, count: 1 },
    ],
  },
};

/**
 * 宝箱ドロップテーブル
 */
export const CHEST_DROP_TABLES = {
  common: {
    rollCount: 1,
    items: [
      { type: 'gold', item: null, weight: 0.5, countRange: [50, 150] },
      { type: 'material', item: '魔力の核', weight: 0.4, countRange: [1, 3] },
      { type: 'material', item: 'R破片', weight: 0.1, countRange: [1, 2] },
    ],
  },

  rare: {
    rollCount: 2,
    items: [
      { type: 'gold', item: null, weight: 0.3, countRange: [100, 300] },
      { type: 'material', item: '魔力の核', weight: 0.3, countRange: [3, 6] },
      { type: 'material', item: 'SR破片', weight: 0.2, countRange: [1, 2] },
      { type: 'material', item: '秘宝の欠片', weight: 0.2, countRange: [1, 1] },
    ],
  },

  epic: {
    rollCount: 3,
    items: [
      { type: 'gold', item: null, weight: 0.2, countRange: [200, 500] },
      { type: 'material', item: 'HR破片', weight: 0.3, countRange: [1, 3] },
      { type: 'material', item: '秘宝の欠片', weight: 0.3, countRange: [1, 2] },
      { type: 'recipe', item: 'random_rare', weight: 0.2, countRange: [1, 1] },
    ],
  },

  legendary: {
    rollCount: 4,
    items: [
      { type: 'gold', item: null, weight: 0.1, countRange: [500, 1000] },
      { type: 'material', item: 'UR破片', weight: 0.3, countRange: [1, 2] },
      { type: 'material', item: '秘宝の欠片', weight: 0.2, countRange: [2, 4] },
      { type: 'recipe', item: 'random_epic', weight: 0.25, countRange: [1, 1] },
      { type: 'equipment', item: 'random_rare', weight: 0.15, countRange: [1, 1] },
    ],
  },
};

/**
 * イベント報酬テーブル
 */
export const EVENT_REWARD_TABLES = {
  // 休息イベント（回復系）
  rest: {
    type: 'rest',
    rewards: [], // 回復のみ、素材なし
  },

  // 商人イベント
  merchant: {
    type: 'merchant',
    rewards: [], // 取引のみ
  },

  // 宝箱発見イベント
  treasure_find: {
    type: 'treasure',
    rewards: [
      { type: 'chest', chestType: 'rare', chance: 0.7 },
      { type: 'chest', chestType: 'epic', chance: 0.25 },
      { type: 'chest', chestType: 'legendary', chance: 0.05 },
    ],
  },

  // 隠し部屋イベント
  secret_room: {
    type: 'secret',
    rewards: [
      { type: 'material', item: '秘宝の欠片', count: 3 },
      { type: 'chest', chestType: 'epic', chance: 1.0 },
    ],
  },

  // 祭壇イベント（リスク＆リターン）
  altar: {
    type: 'altar',
    successRewards: [
      { type: 'material', item: '秘宝の欠片', count: 5 },
      { type: 'buff', item: 'altar_blessing', duration: 10 },
    ],
    failureRewards: [
      { type: 'debuff', item: 'altar_curse', duration: 5 },
    ],
    successChance: 0.6,
  },
};

/**
 * ドロップテーブルを取得
 *
 * @param {string} continent - 大陸ID
 * @param {number} depth - 深度
 * @returns {Object} ドロップテーブル
 */
export function getFloorDropTable(continent, depth) {
  const depthTier = Math.ceil(depth / 10);
  const tableKey = `${continent}_depth_${depthTier}`;

  return FLOOR_DROP_TABLES[tableKey] || FLOOR_DROP_TABLES.default;
}

/**
 * ボスドロップテーブルを取得（フォールバック対応）
 *
 * 優先順位: カードID固有 → カテゴリ → 属性 → default
 *
 * @param {string} cardIdOrBossId - カードID または ボスID
 * @param {Object} [options] - オプション
 * @param {string|string[]} [options.category] - カテゴリ（フォールバック用）
 * @param {string} [options.attribute] - 属性（フォールバック用）
 * @returns {Object} ドロップテーブル
 */
export function getBossDropTable(cardIdOrBossId, options = {}) {
  const { category, attribute } = options;

  // 1. カードID/ボスID固有テーブルをチェック
  if (cardIdOrBossId && BOSS_DROP_TABLES[cardIdOrBossId]) {
    return BOSS_DROP_TABLES[cardIdOrBossId];
  }

  // 2. カテゴリテーブルをチェック
  if (category) {
    const categoryTable = getCategoryBossDropTable(category);
    if (categoryTable) {
      return categoryTable;
    }
  }

  // 3. 属性テーブルをチェック
  if (attribute && ATTRIBUTE_BOSS_DROP_TABLES[attribute]) {
    return ATTRIBUTE_BOSS_DROP_TABLES[attribute];
  }

  // 4. デフォルトにフォールバック
  return BOSS_DROP_TABLES.default;
}

/**
 * カテゴリ別ボスドロップテーブルを取得
 *
 * @param {string|string[]} category - カテゴリ名（文字列または配列）
 * @returns {Object|null} ドロップテーブル
 */
export function getCategoryBossDropTable(category) {
  if (!category) return null;

  // 配列の場合は各要素をチェック
  if (Array.isArray(category)) {
    for (const cat of category) {
      const table = getCategoryBossDropTable(cat);
      if (table) return table;
    }
    return null;
  }

  // 文字列でない場合はnullを返す
  if (typeof category !== 'string') {
    return null;
  }

  // 【】で囲まれていない場合は追加
  const normalizedCategory = category.startsWith('【')
    ? category
    : `【${category}】`;

  // 完全一致
  if (CATEGORY_BOSS_DROP_TABLES[normalizedCategory]) {
    return CATEGORY_BOSS_DROP_TABLES[normalizedCategory];
  }

  // 部分一致（カテゴリが複数含まれる場合）
  for (const [key, table] of Object.entries(CATEGORY_BOSS_DROP_TABLES)) {
    if (category.includes(key) || normalizedCategory.includes(key)) {
      return table;
    }
  }

  return null;
}

/**
 * 宝箱ドロップテーブルを取得
 *
 * @param {string} chestType - 宝箱タイプ
 * @returns {Object} ドロップテーブル
 */
export function getChestDropTable(chestType) {
  return CHEST_DROP_TABLES[chestType] || CHEST_DROP_TABLES.common;
}

/**
 * カテゴリ別ドロップテーブル
 * キー: カテゴリ名（【】含む）
 *
 * 設計準拠: crafting_system_design.md
 * - 種族系カテゴリ（13グループ）
 * - 派閥系カテゴリ（15グループ）
 */
export const CATEGORY_DROP_TABLES = {
  // ============================================================
  // 種族系カテゴリ（何であるか）- 13グループ
  // ============================================================

  // ========== 1. ドラゴン系 ==========
  // 対象: ドラゴン, ワイバーン, サラマンダー
  '【ドラゴン】': {
    materials: [
      { item: '竜鱗', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '竜王の逆鱗', weight: 1 },
    ],
  },
  '【ワイバーン】': {
    materials: [
      { item: '竜鱗', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '竜王の逆鱗', weight: 1 },
    ],
  },
  '【サラマンダー】': {
    materials: [
      { item: '竜鱗', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '竜王の逆鱗', weight: 1 },
    ],
  },

  // ========== 2. ビースト系 ==========
  // 対象: ビースト, ビースト・猫, ビースト・狸, ビースト・狼, ビースト・フロッグ, ビースト・鹿, ビースト・イノシシ, 幻獣
  '【ビースト】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・猫】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・狸】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・狼】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・フロッグ】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・鹿】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【ビースト・イノシシ】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },
  '【幻獣】': {
    materials: [
      { item: '獣の牙', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '獣王の牙', weight: 1 },
    ],
  },

  // ========== 3. スピリット ==========
  // 対象: スピリット
  '【スピリット】': {
    materials: [
      { item: '霊魂のエーテル', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '精霊王の涙', weight: 1 },
    ],
  },

  // ========== 4. 鳥系 ==========
  // 対象: 鳥, 鳥・カラス, 鳥・カモメ
  '【鳥】': {
    materials: [
      { item: '風切り羽', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '天翔の羽根', weight: 1 },
    ],
  },
  '【鳥・カラス】': {
    materials: [
      { item: '風切り羽', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '天翔の羽根', weight: 1 },
    ],
  },
  '【鳥・カモメ】': {
    materials: [
      { item: '風切り羽', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '天翔の羽根', weight: 1 },
    ],
  },

  // ========== 5. ゴーレム系 ==========
  // 対象: ゴーレム, ガーディアン
  '【ゴーレム】': {
    materials: [
      { item: '魔力のコア', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '古代のコア', weight: 1 },
    ],
  },
  '【ガーディアン】': {
    materials: [
      { item: '魔力のコア', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '古代のコア', weight: 1 },
    ],
  },

  // ========== 6. プラント系 ==========
  // 対象: プラント
  '【プラント】': {
    materials: [
      { item: '生命の種子', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '世界樹の雫', weight: 1 },
    ],
  },

  // ========== 7. スライム系 ==========
  // 対象: スライム, コア・ビースト
  '【スライム】': {
    materials: [
      { item: '粘液核', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '王核スライム', weight: 1 },
    ],
  },
  '【コア・ビースト】': {
    materials: [
      { item: '粘液核', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '王核スライム', weight: 1 },
    ],
  },

  // ========== 8. 虫類 ==========
  // 対象: インセクト, インセクト・アリ, インセクト・ビートル, インセクト・蜘蛛, インセクト・蛾, インセクト・アメンボ
  '【インセクト】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },
  '【インセクト・アリ】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },
  '【インセクト・ビートル】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },
  '【インセクト・蜘蛛】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },
  '【インセクト・蛾】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },
  '【インセクト・アメンボ】': {
    materials: [
      { item: '虫殻の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '女王蟻の触角', weight: 1 },
    ],
  },

  // ========== 9. 機械 ==========
  // 対象: マシン
  '【マシン】': {
    materials: [
      { item: '機械部品', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: 'エネルギーコア', weight: 1 },
    ],
  },

  // ========== 10. 魔法生物 ==========
  // 対象: 魔族, 魔導士, ウィザード
  // レア素材: 魔族→魔王の角, 魔導士→賢者の石
  '【魔族】': {
    materials: [
      { item: '魔力結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '魔王の角', weight: 1 },
    ],
  },
  '【魔導士】': {
    materials: [
      { item: '魔力結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '賢者の石', weight: 1 },
    ],
  },
  '【ウィザード】': {
    materials: [
      { item: '魔力結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '魔王の角', weight: 1 },
    ],
  },

  // ========== 11. 霊体 ==========
  // 対象: ゴースト, スケルトン
  '【ゴースト】': {
    materials: [
      { item: '怨念の残滓', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '冥界の灯火', weight: 1 },
    ],
  },
  '【スケルトン】': {
    materials: [
      { item: '怨念の残滓', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '冥界の灯火', weight: 1 },
    ],
  },

  // ========== 12. 爬虫類 ==========
  // 対象: スネーク
  '【スネーク】': {
    materials: [
      { item: '蛇皮', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '蛇王の牙', weight: 1 },
    ],
  },

  // ========== 13. ヒューマノイド ==========
  // 対象: ヒューマノイド, カイザー, ソルジャー
  '【ヒューマノイド】': {
    materials: [
      { item: '人型の証', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '英雄の魂', weight: 1 },
    ],
  },
  '【カイザー】': {
    materials: [
      { item: '人型の証', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '英雄の魂', weight: 1 },
    ],
  },
  '【ソルジャー】': {
    materials: [
      { item: '人型の証', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '英雄の魂', weight: 1 },
    ],
  },

  // ============================================================
  // 派閥系カテゴリ（どこに属するか）- 15グループ
  // ============================================================

  // ========== 1. ソウルカース ==========
  // 対象: ソウルカース
  '【ソウルカース】': {
    materials: [
      { item: '呪縛の鎖', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '魂喰いの鎖', weight: 1 },
    ],
  },

  // ========== 2. タイドウェーブ ==========
  // 対象: タイドウェーブ, マーメイド, リヴァイアサン
  '【タイドウェーブ】': {
    materials: [
      { item: '潮流の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '海神の涙', weight: 1 },
    ],
  },
  '【マーメイド】': {
    materials: [
      { item: '潮流の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '海神の涙', weight: 1 },
    ],
  },
  '【リヴァイアサン】': {
    materials: [
      { item: '潮流の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '海神の涙', weight: 1 },
    ],
  },

  // ========== 3. パペットマスター ==========
  // 対象: パペットマスター
  '【パペットマスター】': {
    materials: [
      { item: '操糸', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '傀儡師の心臓', weight: 1 },
    ],
  },

  // ========== 4. ダークドウェラ ==========
  // 対象: ダークドウェラ, シャドウ
  '【ダークドウェラ】': {
    materials: [
      { item: '深闇の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '深淵の核', weight: 1 },
    ],
  },
  '【シャドウ】': {
    materials: [
      { item: '深闇の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '深淵の核', weight: 1 },
    ],
  },

  // ========== 5. マグマフォージ ==========
  // 対象: マグマフォージ
  '【マグマフォージ】': {
    materials: [
      { item: '溶岩核', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '炉心の結晶', weight: 1 },
    ],
  },

  // ========== 6. 蛮族 ==========
  // 対象: 蛮族
  '【蛮族】': {
    materials: [
      { item: '蛮勇の証', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '族長の魂', weight: 1 },
    ],
  },

  // ========== 7. エクラシア ==========
  // 対象: エクラシア, プリンセス
  '【エクラシア】': {
    materials: [
      { item: '時の歯車', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '永劫の砂', weight: 1 },
    ],
  },
  '【プリンセス】': {
    materials: [
      { item: '時の歯車', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '永劫の砂', weight: 1 },
    ],
  },

  // ========== 8. 飛翔連合 ==========
  // 対象: スカイレジェンド, ウィング・トリビューン, フェニックス
  // レア素材: スカイレジェンド→蒼天の冠羽, フェニックス→不死鳥の炎羽
  '【スカイレジェンド】': {
    materials: [
      { item: '天空の羽根', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '蒼天の冠羽', weight: 1 },
    ],
  },
  '【ウィング・トリビューン】': {
    materials: [
      { item: '天空の羽根', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '蒼天の冠羽', weight: 1 },
    ],
  },
  '【フェニックス】': {
    materials: [
      { item: '天空の羽根', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '不死鳥の炎羽', weight: 1 },
    ],
  },

  // ========== 9. 深淵勢力 ==========
  // 対象: アビスソウル, ディープシャドウ, デーモン, ブラック・オラクル
  // レア素材: アビスソウル→虚無の心臓, ブラック・オラクル→預言の瞳
  '【アビスソウル】': {
    materials: [
      { item: '深淵の闘気', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '虚無の心臓', weight: 1 },
    ],
  },
  '【ディープシャドウ】': {
    materials: [
      { item: '深淵の闘気', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '虚無の心臓', weight: 1 },
    ],
  },
  '【デーモン】': {
    materials: [
      { item: '深淵の闘気', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '虚無の心臓', weight: 1 },
    ],
  },
  '【ブラック・オラクル】': {
    materials: [
      { item: '深淵の闘気', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '預言の瞳', weight: 1 },
    ],
  },

  // ========== 10. 虚蝕 ==========
  // 対象: 虚蝕
  '【虚蝕】': {
    materials: [
      { item: '虚無の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '侵蝕の核', weight: 1 },
    ],
  },

  // ========== 11. 聖光 ==========
  // 対象: ルミナフォース, 天使, エンジェル
  // レア素材: ルミナフォース→聖女の祈り
  '【ルミナフォース】': {
    materials: [
      { item: '聖光の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '聖女の祈り', weight: 1 },
    ],
  },
  '【天使】': {
    materials: [
      { item: '聖光の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '聖女の祈り', weight: 1 },
    ],
  },
  '【エンジェル】': {
    materials: [
      { item: '聖光の結晶', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '聖女の祈り', weight: 1 },
    ],
  },

  // ========== 12. 時空 ==========
  // 対象: トラベラー
  '【トラベラー】': {
    materials: [
      { item: '時空の砂', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '次元の鍵', weight: 1 },
    ],
  },

  // ========== 13. 毒牙 ==========
  // 対象: ポイズンウェイル
  '【ポイズンウェイル】': {
    materials: [
      { item: '毒腺', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '猛毒の心臓', weight: 1 },
    ],
  },

  // ========== 14. 拘束 ==========
  // 対象: 鎖
  '【鎖】': {
    materials: [
      { item: '鎖の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '封印の鎖', weight: 1 },
    ],
  },

  // ========== 15. 宿敵 ==========
  // 対象: ライバル
  '【ライバル】': {
    materials: [
      { item: '闘志の欠片', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.05,
    rarePool: [
      { item: '宿命の証', weight: 1 },
    ],
  },
};

/**
 * カードID別ドロップテーブル（特定カード専用）
 * キー: カードID
 */
export const CARD_DROP_TABLES = {
  // ========== 炎属性 特別カード ==========
  'C0000028': {  // 炎竜母フレイマ
    guaranteed: [
      { item: '竜鱗', count: 3 },
    ],
    materials: [
      { item: '竜王の逆鱗', chance: 0.5, countRange: [1, 2] },
    ],
    rareChance: 0.15,
    rarePool: [
      { item: '始祖竜の心臓', weight: 1 },
    ],
  },
  'C0000001': {  // フレア・ドラゴン
    materials: [
      { item: '竜鱗', chance: 0.6, countRange: [1, 2] },
      { item: '炎の結晶', chance: 0.8, countRange: [2, 4] },
    ],
  },

  // ========== 水属性 特別カード ==========
  'C0000038': {  // アクアレギナ
    guaranteed: [
      { item: '海神の涙', count: 2 },
    ],
    materials: [
      { item: '海神の涙', chance: 0.6, countRange: [1, 3] },
    ],
    rareChance: 0.2,
    rarePool: [
      { item: '海神の涙', weight: 1 },
    ],
  },

  // ========== 闇属性 特別カード ==========
  'C0000161': {  // 灯魔龍ランプデビル
    materials: [
      { item: '竜鱗', chance: 0.4, countRange: [1, 2] },
      { item: '闇の結晶', chance: 0.6, countRange: [2, 3] },
    ],
    rareChance: 0.1,
    rarePool: [
      { item: '深淵の闘気', weight: 1 },
    ],
  },

  // 将来的に追加可能...
};

/**
 * カテゴリドロップテーブルを取得
 *
 * @param {string|string[]} category - カテゴリ名（文字列または配列）
 * @returns {Object|null} ドロップテーブル
 */
export function getCategoryDropTable(category) {
  if (!category) return null;

  // 配列の場合は各要素をチェック
  if (Array.isArray(category)) {
    for (const cat of category) {
      const table = getCategoryDropTable(cat);
      if (table) return table;
    }
    return null;
  }

  // 文字列でない場合はnullを返す
  if (typeof category !== 'string') {
    console.warn('[getCategoryDropTable] category is not a string or array:', category);
    return null;
  }

  // 【】で囲まれていない場合は追加
  const normalizedCategory = category.startsWith('【')
    ? category
    : `【${category}】`;

  // 完全一致
  if (CATEGORY_DROP_TABLES[normalizedCategory]) {
    return CATEGORY_DROP_TABLES[normalizedCategory];
  }

  // 部分一致（カテゴリが複数含まれる場合）
  for (const [key, table] of Object.entries(CATEGORY_DROP_TABLES)) {
    if (category.includes(key) || normalizedCategory.includes(key)) {
      return table;
    }
  }

  return null;
}

/**
 * 複数カテゴリのドロップテーブルを全て取得
 * 例: 【ドラゴン】【ビースト】 → [ドラゴンテーブル, ビーストテーブル]
 *
 * @param {string|string[]} category - カテゴリ名（文字列または配列）
 * @returns {Array<{category: string, table: Object}>} マッチした全カテゴリのテーブル配列
 */
export function getAllCategoryDropTables(category) {
  const results = [];
  if (!category) return results;

  // 配列の場合は各要素を処理
  if (Array.isArray(category)) {
    for (const cat of category) {
      const catResults = getAllCategoryDropTables(cat);
      results.push(...catResults);
    }
    return results;
  }

  // 文字列でない場合は空配列を返す
  if (typeof category !== 'string') {
    return results;
  }

  // 【】で囲まれていない場合は追加して正規化
  const normalizedCategory = category.startsWith('【')
    ? category
    : `【${category}】`;

  // 全てのカテゴリテーブルをチェック
  for (const [key, table] of Object.entries(CATEGORY_DROP_TABLES)) {
    // 元の文字列または正規化した文字列でマッチ
    if (category.includes(key) || normalizedCategory === key) {
      results.push({ category: key, table });
    }
  }

  return results;
}

/**
 * カードIDドロップテーブルを取得
 *
 * @param {string} cardId - カードID
 * @returns {Object|null} ドロップテーブル
 */
export function getCardDropTable(cardId) {
  if (!cardId) return null;
  return CARD_DROP_TABLES[cardId] || null;
}

/**
 * ========================================
 * 経験値オーブドロップシステム（固定階層ベース）
 * ========================================
 *
 * 階層区分:
 * - 序盤: 1-10F
 * - 前半: 11-25F
 * - 中盤: 26-50F
 * - 後半: 51-75F
 * - 終盤: 76F+
 */

/**
 * 通常戦闘の経験値オーブドロップ（低確率）
 */
export const EXP_ORB_BATTLE_DROPS = {
  early: {      // 1-10F
    orb: 'exp_orb_small',
    chance: 0.10,
    countRange: [1, 1],
  },
  earlyMid: {   // 11-25F
    orb: 'exp_orb_small',
    chance: 0.15,
    countRange: [1, 2],
  },
  mid: {        // 26-50F
    orb: 'exp_orb_medium',
    chance: 0.10,
    countRange: [1, 1],
  },
  lateMid: {    // 51-75F
    orb: 'exp_orb_medium',
    chance: 0.15,
    countRange: [1, 2],
  },
  late: {       // 76F+
    orb: 'exp_orb_large',
    chance: 0.10,
    countRange: [1, 1],
  },
};

/**
 * 宝箱の経験値オーブドロップ（確率）
 */
export const EXP_ORB_CHEST_DROPS = {
  early: {      // 1-10F
    primary: { orb: 'exp_orb_small', chance: 0.25, countRange: [2, 3] },
    alt: null,
  },
  earlyMid: {   // 11-25F
    primary: { orb: 'exp_orb_small', chance: 0.20, countRange: [3, 5] },
    alt: { orb: 'exp_orb_medium', chance: 0.10, countRange: [1, 1] },
  },
  mid: {        // 26-50F
    primary: { orb: 'exp_orb_medium', chance: 0.30, countRange: [1, 2] },
    alt: null,
  },
  lateMid: {    // 51-75F
    primary: { orb: 'exp_orb_medium', chance: 0.25, countRange: [2, 3] },
    alt: { orb: 'exp_orb_large', chance: 0.10, countRange: [1, 1] },
  },
  late: {       // 76F+
    primary: { orb: 'exp_orb_large', chance: 0.40, countRange: [1, 2] },
    alt: null,
  },
};

/**
 * ボスの経験値オーブドロップ（高確率）
 */
export const EXP_ORB_BOSS_DROPS = {
  10: { orb: 'exp_orb_small', chance: 0.70, countRange: [3, 5] },
  20: { orb: 'exp_orb_medium', chance: 0.75, countRange: [1, 2] },
  30: { orb: 'exp_orb_medium', chance: 0.80, countRange: [2, 3] },
  40: {
    primary: { orb: 'exp_orb_medium', chance: 0.60, countRange: [3, 3] },
    alt: { orb: 'exp_orb_large', chance: 0.20, countRange: [1, 1] },
  },
  50: { orb: 'exp_orb_large', chance: 0.85, countRange: [1, 2] },
  60: { orb: 'exp_orb_large', chance: 0.85, countRange: [2, 2] },
  70: { orb: 'exp_orb_large', chance: 0.85, countRange: [2, 2] },
  80: { orb: 'exp_orb_large', chance: 0.85, countRange: [2, 2] },
  90: { orb: 'exp_orb_large', chance: 0.85, countRange: [2, 2] },
  100: {
    guaranteed: [
      { orb: 'exp_orb_large', count: 3 },
      { orb: 'exp_orb_super', count: 1 },
    ],
    chance: 0.90,
  },
};

/**
 * ダンジョンクリア報酬（確定）
 */
export const EXP_ORB_CLEAR_REWARDS = {
  10: [{ orb: 'exp_orb_small', count: 5 }],
  20: [{ orb: 'exp_orb_medium', count: 1 }],
  30: [{ orb: 'exp_orb_medium', count: 2 }],
  50: [{ orb: 'exp_orb_large', count: 1 }],
  100: [
    { orb: 'exp_orb_large', count: 2 },
    { orb: 'exp_orb_super', count: 1 },
  ],
};

/**
 * 階層から経験値オーブドロップ区分を取得
 * @param {number} floor - 現在階層
 * @returns {string} 区分キー
 */
export function getExpOrbFloorTier(floor) {
  if (floor <= 10) return 'early';
  if (floor <= 25) return 'earlyMid';
  if (floor <= 50) return 'mid';
  if (floor <= 75) return 'lateMid';
  return 'late';
}

/**
 * 通常戦闘の経験値オーブドロップを計算
 * @param {number} floor - 現在階層
 * @returns {Object|null} ドロップ結果 { orbId, count } or null
 */
export function rollExpOrbBattleDrop(floor) {
  const tier = getExpOrbFloorTier(floor);
  const dropInfo = EXP_ORB_BATTLE_DROPS[tier];

  if (Math.random() < dropInfo.chance) {
    const count = Math.floor(
      Math.random() * (dropInfo.countRange[1] - dropInfo.countRange[0] + 1)
    ) + dropInfo.countRange[0];
    return { orbId: dropInfo.orb, count };
  }
  return null;
}

/**
 * 宝箱の経験値オーブドロップを計算
 * @param {number} floor - 現在階層
 * @returns {Object|null} ドロップ結果 { orbId, count } or null
 */
export function rollExpOrbChestDrop(floor) {
  const tier = getExpOrbFloorTier(floor);
  const dropInfo = EXP_ORB_CHEST_DROPS[tier];

  // 代替ドロップを先にチェック（より希少）
  if (dropInfo.alt && Math.random() < dropInfo.alt.chance) {
    const count = Math.floor(
      Math.random() * (dropInfo.alt.countRange[1] - dropInfo.alt.countRange[0] + 1)
    ) + dropInfo.alt.countRange[0];
    return { orbId: dropInfo.alt.orb, count };
  }

  // プライマリドロップ
  if (Math.random() < dropInfo.primary.chance) {
    const count = Math.floor(
      Math.random() * (dropInfo.primary.countRange[1] - dropInfo.primary.countRange[0] + 1)
    ) + dropInfo.primary.countRange[0];
    return { orbId: dropInfo.primary.orb, count };
  }

  return null;
}

/**
 * ボスの経験値オーブドロップを計算
 * @param {number} bossFloor - ボス階層 (10, 20, 30, ...)
 * @returns {Array} ドロップ結果 [{ orbId, count }, ...]
 */
export function rollExpOrbBossDrop(bossFloor) {
  // 正規化: 10の倍数に丸める
  const normalizedFloor = Math.min(100, Math.floor(bossFloor / 10) * 10);
  const dropInfo = EXP_ORB_BOSS_DROPS[normalizedFloor] || EXP_ORB_BOSS_DROPS[10];

  const results = [];

  // 100Fボスは確定報酬
  if (dropInfo.guaranteed) {
    if (Math.random() < dropInfo.chance) {
      for (const item of dropInfo.guaranteed) {
        results.push({ orbId: item.orb, count: item.count });
      }
    }
    return results;
  }

  // 代替ドロップ（40F専用）
  if (dropInfo.alt && Math.random() < dropInfo.alt.chance) {
    const count = Math.floor(
      Math.random() * (dropInfo.alt.countRange[1] - dropInfo.alt.countRange[0] + 1)
    ) + dropInfo.alt.countRange[0];
    results.push({ orbId: dropInfo.alt.orb, count });
    return results;
  }

  // プライマリドロップ
  const primaryInfo = dropInfo.primary || dropInfo;
  if (Math.random() < primaryInfo.chance) {
    const count = Math.floor(
      Math.random() * (primaryInfo.countRange[1] - primaryInfo.countRange[0] + 1)
    ) + primaryInfo.countRange[0];
    results.push({ orbId: primaryInfo.orb, count });
  }

  return results;
}

/**
 * ダンジョンクリア時の経験値オーブ報酬を取得
 * @param {number} dungeonSize - ダンジョン規模 (10, 20, 30, 50, 100)
 * @returns {Array} 確定報酬 [{ orbId, count }, ...]
 */
export function getExpOrbClearReward(dungeonSize) {
  // 最も近い定義済み規模を選択
  const sizes = [10, 20, 30, 50, 100];
  let targetSize = sizes[0];
  for (const size of sizes) {
    if (dungeonSize >= size) targetSize = size;
  }

  const rewards = EXP_ORB_CLEAR_REWARDS[targetSize] || [];
  return rewards.map(r => ({ orbId: r.orb, count: r.count }));
}

// ============================================================
// 最終ボス破片ドロップシステム（設計書 v0.5 準拠・6段階）
// ============================================================

/**
 * 最終ボス（ダンジョンクリア時）の破片ドロップテーブル
 * 階層に応じてドロップする破片が変わる（20階刻み6段階）
 *
 * 設計書 v0.5 より:
 * - 10-20F（外縁部）: C破片×3 + UC破片×1
 * - 21-40F（浅層部）: R破片×2
 * - 41-60F（中層部）: SR破片×2 + UR破片×1
 * - 61-80F（深部）: HR破片×1 + SEC破片×1
 * - 81-95F（最深部）: ALT破片×1、SP破片20%追加
 * - 96-100F（最深部）: ALT破片×1、SP破片40%、GR破片15%追加
 * - 110F（深淵の彼方）: SP+GR確定、ALT50%追加
 */
export const FINAL_BOSS_FRAGMENT_DROPS = {
  // 外縁部: 10-20F
  '10-20': {
    guaranteed: [
      { item: 'C破片', count: 3 },
      { item: 'UC破片', count: 1 },
    ],
    additional: [],
  },

  // 浅層部: 21-40F
  '21-40': {
    guaranteed: [{ item: 'R破片', count: 2 }],
    additional: [],
  },

  // 中層部: 41-60F
  '41-60': {
    guaranteed: [
      { item: 'SR破片', count: 2 },
      { item: 'UR破片', count: 1 },
    ],
    additional: [],
  },

  // 深部: 61-80F
  '61-80': {
    guaranteed: [
      { item: 'HR破片', count: 1 },
      { item: 'SEC破片', count: 1 },
    ],
    additional: [],
  },

  // 最深部: 81-100F
  '81-95': {
    guaranteed: [{ item: 'ALT破片', count: 1 }],
    additional: [
      { item: 'SP破片', chance: 0.20, count: 1 },
    ],
  },
  '96-100': {
    guaranteed: [{ item: 'ALT破片', count: 1 }],
    additional: [
      { item: 'SP破片', chance: 0.40, count: 1 },
      { item: 'GR破片', chance: 0.15, count: 1 },
    ],
  },

  // 深淵の彼方: 110F (GR×GR専用)
  '110': {
    guaranteed: [
      { item: 'SP破片', count: 1 },
      { item: 'GR破片', count: 1 },
    ],
    additional: [
      { item: 'ALT破片', chance: 0.50, count: 1 },
    ],
  },
};

/**
 * 最終ボスの破片ドロップを取得
 * @param {number} floor - ダンジョン最終階層
 * @returns {{ guaranteed: Array, rolled: Array }} 確定ドロップと抽選結果
 */
export function getFinalBossFragmentDrops(floor) {
  // 階層範囲を特定（6段階・20階刻み）
  let rangeKey;
  if (floor >= 110) {
    rangeKey = '110';
  } else if (floor >= 96) {
    rangeKey = '96-100';
  } else if (floor >= 81) {
    rangeKey = '81-95';
  } else if (floor >= 61) {
    rangeKey = '61-80';
  } else if (floor >= 41) {
    rangeKey = '41-60';
  } else if (floor >= 21) {
    rangeKey = '21-40';
  } else {
    rangeKey = '10-20';
  }

  const dropTable = FINAL_BOSS_FRAGMENT_DROPS[rangeKey];
  if (!dropTable) {
    return { guaranteed: [], rolled: [] };
  }

  // 確定ドロップ
  const guaranteed = dropTable.guaranteed.map(d => ({
    item: d.item,
    count: d.count,
  }));

  // 追加ドロップの抽選
  const rolled = [];
  for (const additional of dropTable.additional) {
    if (Math.random() < additional.chance) {
      rolled.push({
        item: additional.item,
        count: additional.count,
      });
    }
  }

  return { guaranteed, rolled };
}

/**
 * 破片ドロップの階層範囲説明を取得
 * @param {number} floor - 階層
 * @returns {string} 説明文
 */
export function getFragmentDropDescription(floor) {
  if (floor >= 110) {
    return '深淵の彼方: SP破片+GR破片確定、ALT破片50%';
  } else if (floor >= 96) {
    return '最深部: ALT破片確定、SP破片40%、GR破片15%';
  } else if (floor >= 90) {
    return '最深部: SEC破片確定、SP破片20%';
  } else if (floor >= 75) {
    return '深部: HR破片確定';
  } else if (floor >= 60) {
    return '深部: UR破片確定';
  } else if (floor >= 45) {
    return '中層部: SR破片確定';
  } else if (floor >= 30) {
    return '中層部: R破片確定';
  } else if (floor >= 16) {
    return '外縁部: UC破片確定';
  } else {
    return '外縁部: C破片確定';
  }
}

export default {
  FLOOR_DROP_TABLES,
  BOSS_DROP_TABLES,
  CATEGORY_BOSS_DROP_TABLES,
  ATTRIBUTE_BOSS_DROP_TABLES,
  CHEST_DROP_TABLES,
  EVENT_REWARD_TABLES,
  CATEGORY_DROP_TABLES,
  CARD_DROP_TABLES,
  EXP_ORB_BATTLE_DROPS,
  EXP_ORB_CHEST_DROPS,
  EXP_ORB_BOSS_DROPS,
  EXP_ORB_CLEAR_REWARDS,
  FINAL_BOSS_FRAGMENT_DROPS,
  getFloorDropTable,
  getBossDropTable,
  getCategoryBossDropTable,
  getChestDropTable,
  getCategoryDropTable,
  getAllCategoryDropTables,
  getCardDropTable,
  getExpOrbFloorTier,
  rollExpOrbBattleDrop,
  rollExpOrbChestDrop,
  rollExpOrbBossDrop,
  getExpOrbClearReward,
  getFinalBossFragmentDrops,
  getFragmentDropDescription,
};
